import {
    Alert, AlertIcon, Avatar, Box, Button, Card, CardBody, CardHeader, Select, Flex, Grid, Input, InputGroup, Stack, Text, useColorModeValue, useToast, InputLeftElement, TableContainer, Table, Tr, Tbody, Td, IconButton, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Image, SkeletonCircle, Skeleton
} from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'

import { useStateContext } from '../../context/ContextProvider'
import { useNavigate } from 'react-router-dom'
import { DeleteIcon, SearchIcon } from '@chakra-ui/icons';
import { PiPlusBold } from 'react-icons/pi';
import countryData from '../../assets/dataJson/countries.json';
import { useTranslation } from 'react-i18next';
import MyPagination from '../../components/MyPagination';
import axiosClient from '../../axios-client';

function GestPays() {
    const { user } = useStateContext();
    const navigate = useNavigate()
    const [listPays, setListPays] = useState([])
    const [message, setMessage] = useState('');
    const [message2, setMessage2] = useState('');
    const { t } = useTranslation();

    const [loadingData, setLoadingData] = useState(true)

    const [paysName, setPaysName] = useState('');
    const [deletePaysId, setDeletePaysId] = useState(null);

    const [selectedPays, setSelectedPays] = useState(null);

    const [addPays, setAddPays] = useState(false)

    const inputColor = useColorModeValue("gray.300", "gray.600")
    //search variable
    const [searchTerm, setSearchTerm] = useState('');

    //toast variable
    const toast = useToast()

    const cancelRef = React.useRef()
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({});
    const [selectedCountryValue, setSelectedCountryValue] = useState('');

    const colorbg = useColorModeValue('gray.200', '#2d3748')
    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')

    const [paginationData, setPaginationData] = useState()
    const [checkLengthData, setCheckLengthData] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };


    ////////////////////////////////the size of the table//////////////////////////////
    const [currentPage, setCurrentPage] = useState(0);

    const PAGE_SIZE = 5;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 5);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    //////////////////////////////////////////////////////////////////////////////////
    useEffect(() => {
        // setLoadingData(true)
        axiosClient.get(`/pays/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}`)
            .then((response) => {

                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setListPays(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });
    }, [user, pageSize, currentPage, searchTerm]);

    function update() {
        axiosClient.get(`/pays/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}`)
            .then((response) => {

                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setListPays(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });
    }

    const handleCountryChange = (e) => {
        setSelectedCountry(countries.find(
            (country) => country.value === e.target.value
        ))

        setSelectedCountryValue(countries.find(
            (country) => country.value === e.target.value).value.toLowerCase())

    };
    const getFlagImagePath = () => {
        if (selectedCountryValue) {
            return require(`../../assets/images/countries/${selectedCountryValue}.png`);
        }
        return null;
    };

    useEffect(() => {
        const Mycountries = [];
        const data = countryData;
        for (let index = 0; index < data.countries.length; index++) {
            Mycountries.push({
                value: data.countries[index].value,
                label: data.countries[index].label.substring(5, 50)
            });
        }
        setCountries(Mycountries);
    }, []);
    const AjoutPays = async (e) => {
        setIsLoading(true)
        if (!selectedCountry.label) {
            setMessage(t("Veuillez choisir un pays"))
            setIsLoading(false)
            return;
        }

        const formData = new FormData()
        if (selectedCountry) {
            formData.append("name", selectedCountry.label);
            formData.append("code", selectedCountry.value);

        }

        const flagImage = await fetch(getFlagImagePath());
        const flagImageBlob = await flagImage.blob() // Convert the image to a Blob
        const flagImageFile = new File([flagImageBlob], `${selectedCountryValue}.png`, { type: 'image/png' });


        formData.append('flag', flagImageFile);

        if (listPays.length > 0) {
            const check = listPays.find(obj => {

                return obj.name === selectedCountry.label;
            })

            if (check) {
                setIsLoading(false)
                setMessage(t('Ce pays existe déja!'))
                return 
            }
        }
        await axiosClient.post('pays/create/', formData)
            .then((response) => {
                // setListPays([response.data, ...listPays]);
                setSelectedCountry('')
                setMessage("")
                setAddPays(false)
                toast({
                    description: ` ${selectedCountry.label} ${t("est ajouté avec succès")} `,
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right',
                })
                setIsLoading(false)
                update()
            }).catch((err) => {
                setIsLoading(false)
                const response = err.response;
            
            })

    }


    const handleDeletePays = (id) => {
        if (!id) return;
        axiosClient.delete(`pays/delete/${id}/`)
            .then((response) => {
                setListPays((prevData) => prevData.filter((row) => row.id !== id));
                toast({
                    description: t("Le pays est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
                onCloseAlert()
            })
            .catch((error) => {
                // console.error(error);
            });
    }
    return (
        <Box bgSize="auto">

            <Flex>
                <Box w="90%" mt={3} mb={5} >
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span  >Gestion des pays</span></Text>
                </Box>
            </Flex>
            <Box direction='column' mt={{ sm: '25px', md: '0px' }}>

                <Grid templateColumns={{ sm: "1fr", md: "1fr", lg: "1fr", xl: "2.5fr 2.5fr " }} px={{ base: 1, md: 4, lg: 4, xl: 5 }} gap='40px' >

                    <Card
                        bg={useColorModeValue("gray.200", "gray.700")}
                        display={'flex'}
                        p='16px'
                    >
                        <CardHeader p='1px 5px' display={'flex'} justifyContent={"space-between"}>
                            <Text fontSize='lg' color={useColorModeValue("gray.700", "white")} fontWeight='bold'>
                                {t("Pays")}
                            </Text>
                            <Button onClick={() => setAddPays(true)} _hover={"none"} color={"white"} w={"20%"} backgroundColor={"gray.600"} rounded={'xl'} size={'sm'}>
                                <PiPlusBold />
                            </Button>
                        </CardHeader>
                        <CardBody px='5px'>
                            <Flex direction='column'>

                                {addPays &&
                                    <>
                                        <Flex flexDirection={"column"}>

                                            {message &&
                                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                                    <AlertIcon />
                                                    {message}
                                                </Alert>
                                            }
                                            <Select
                                                borderColor={inputColor}
                                                mb={2} size={"sm"} rounded={'lg'}
                                                id="pays"
                                                name="pays"
                                                defaultValue={selectedCountry}
                                                onChange={handleCountryChange}
                                                bg={colorbg}
                                                color={txtcolor}
                                                _focus={{ bg: colorbg, borderColor: "transparent" }}
                                            >
                                                <option>-- {t("Choisir un pays")} --</option>
                                                {countries.sort((a, b) => a.label.localeCompare(b.label)).map((country) => (
                                                    <option
                                                        key={country.value}
                                                        value={country.value}
                                                        bg={colorbg}
                                                        color={txtcolor}
                                                        _hover={{ bg: colorbghover, cursor: "pointer" }}
                                                    >
                                                        {country.label}
                                                    </option>
                                                ))}
                                            </Select>

                                            <Flex flexDirection={'row'} justify={"end"}>
                                                <Button onClick={() => { setAddPays(false); setMessage('') }} _hover={"none"} color={"white"} w={"fit-content"} fontSize={"xs"} colorScheme='red' rounded={'xl'} size={'sm'}>
                                                    {t("Annuler")}
                                                </Button>
                                                <Button
                                                    isLoading={isLoading}
                                                    isDisabled={isLoading} onClick={AjoutPays} ml={2} _hover={"none"} color={"white"} w={"fit-content"} fontSize={"xs"} backgroundColor={"#49b1cc"} rounded={'xl'} size={'sm'}>
                                                    {t("Enregistrer")}
                                                </Button>
                                            </Flex>

                                        </Flex>

                                    </>

                                }
                                <Flex
                                    align={'center'}
                                    justify={'center'}
                                >
                                    <Stack
                                        w={'full'}
                                        maxW='full'
                                        bg={useColorModeValue('gray.200', 'gray.700')}
                                        rounded={'lg'}
                                        p={1}
                                        my={1}>
                                        {/* Search input */}
                                        <Flex
                                            justifyContent="end"
                                            alignItems="center"
                                            direction={{ base: 'column', lg: 'row' }}
                                        >

                                            <InputGroup size={"sm"} w={"100%"}>
                                                <InputLeftElement
                                                    pointerEvents='none'
                                                    children={<SearchIcon color='gray.300' />}
                                                />
                                                <Input
                                                    borderColor={'gray.300'}
                                                    borderRadius={"5"}
                                                    placeholder={t("Recherche...")}
                                                    value={searchTerm}
                                                    mb={4}
                                                    sx={{
                                                        marginLeft: 'auto',
                                                    }}
                                                    onChange={(e) => {
                                                        setCurrentPage(0)
                                                        setSearchTerm(e.target.value)
                                                    }}
                                                />  </InputGroup>

                                        </Flex>
                                        <TableContainer rounded="lg">
                                            <Table size={"sm"} variant='striped' colorScheme="gray">
                                                {loadingData &&
                                                    <Tr>
                                                        <Td><SkeletonCircle size='10' /></Td>

                                                        <Td> <Skeleton height='20px' /></Td>
                                                    </Tr>}
                                                <Tbody>
                                                    {(paginationData?.length !== 0) &&
                                                        listPays.map((row) => (
                                                            <Tr

                                                                p={0}
                                                                key={row.id}
                                                            >
                                                                <Td>
                                                                    <Avatar
                                                                        borderRadius="5px"
                                                                        size={"sm"}
                                                                        src={row.flag}
                                                                        alt={`Flag of ${row.name}`}
                                                                    />
                                                                </Td>

                                                                <Td fontSize={"sm"}>{row.name}</Td>

                                                                <Td>
                                                                    <IconButton
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            setDeletePaysId(row.id);
                                                                            onOpenAlert();
                                                                        }}
                                                                        colorScheme="red"
                                                                        icon={<DeleteIcon />}
                                                                        aria-label={`Delete ${row.name}`}
                                                                    />


                                                                </Td>
                                                            </Tr>
                                                        ))}
                                                    {((searchTerm && paginationData?.length === 0) || (checkLengthData)) && (
                                                        <Tr>
                                                            <Td colSpan={5} fontSize={'sm'}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                                                        </Tr>
                                                    )}
                                                </Tbody>
                                            </Table>

                                        </TableContainer>
                                        {/* Pagination */}
                                        <Flex justify="space-between" align="center" >
                                            <Box flex="1">
                                                <MyPagination
                                                    paginationData={paginationData}
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    PAGE_SIZE={pageSize}
                                                />
                                            </Box>


                                        </Flex>
                                    </Stack>
                                </Flex>

                            </Flex>
                        </CardBody>
                    </Card>
                    <Image minH={"40vh"} src={"https://www.pngall.com/wp-content/uploads/1/World-Map-PNG-Photo.png"} />

                </Grid>

            </Box>

            <AlertDialog
                closeOnOverlayClick={false}
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Supprimer')}
                        </AlertDialogHeader>

                        <AlertDialogBody>


                            <Text>
                                {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                            </Text>

                        </AlertDialogBody>



                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={() => {
                                onCloseAlert()
                            }}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDeletePays(deletePaysId)} colorScheme='red' ml={3} >
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>
    )
}

export default GestPays